module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIcAAAA8CAYAAABM6qm8AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALNJREFUeNrs0rENQGAUhdHHMBK1UsMmKrEFY4jKCjbQmEFiGokdfiI5Z4CX3Jcv67tyiogx3rUv69mmOn7N9Rebnl3FcCTZtTXV65vyAHEgDsSBOBAH4kAciANxIA4QB+JAHIgDcSAOxIE4EAfiAHEgDsSBOBAH4kAciANxIA7E4QWIA3EgDsSBOBAH4kAciANxgDgQB+JAHIgDcSAOxIE4EAeIA3EgDsSBOBAH4uCnbgEGABcHDJuXRrnGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SplashLogoBottom.png
// module id = 5fA2
// module chunks = 1